import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import { toast } from "react-toastify";
import { MenuItem } from "@mui/material";

import "react-toastify/dist/ReactToastify.css";
import {
  Grid,
  Box,
  Typography,
  Card,
  TextField,
} from "@mui/material";
import { keyframes } from "@mui/system";

import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import MedicalAbstractBackground from "./MedicalAbstractBackground ";

const CustomStepper = ({ title }) => (
  <Box mb={3} display="flex" justifyContent="center">
    <Typography
      variant="h6"
      sx={{ fontWeight: "bold", color: "#2e7fae", textAlign: "center" }}
    >
      {title}
    </Typography>
  </Box>
);

function RegisterDevice() {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;

  const date = new Date();
  const currentDate = date.toISOString().split("T")[0];

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [mappingDetails, setMappingDetails] = useState({
    devicename: "",
    devicetype: "",
    manufacturer: "",
    modelnumber: "",
    serialnumber: "",
    description: "",
    ccid: userid,
    
    createdat: currentDate,
  });
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let temp = {};

    if (!mappingDetails.devicename) temp.devicename = "Device Name is required";
    if (!mappingDetails.devicetype) temp.devicetype = "Device Type is required";
    if (!mappingDetails.manufacturer) temp.manufacturer = "Manufacturer is required";
    if (!mappingDetails.modelnumber) temp.modelnumber = "Model Number is required";
    if (!mappingDetails.serialnumber) temp.serialnumber = "Serial Number is required";
    if (!mappingDetails.description) temp.description = "Description is required";

    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  // =================== SUBMIT ===================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error("Please fix validation errors!");
      return;
    }

    setLoading(true);

    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;

      const encryptedData = encryptBody(mappingDetails, secretKey);

      const response = await axios.post("/api/device/create", encryptedData, {
        headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
      });

      if (response.status === 200) {
        const decrypted = decryptBody(response.data, secretKey);
        toast.success(decrypted?.message || "Device Created Successfully!");
        navigate(-1);
      }
    } catch (err) {
      console.error("Error creating device:", err);
      toast.error("Error creating device");
    } finally {
      setLoading(false);
    }
  };

  // Loader Animation
  const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dots = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
<MedicalAbstractBackground/>
      {/* Loader */}
      {loading && (
        <Box
          sx={{
            position: "fixed",
            inset: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "rgba(255,255,255,0.8)",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              width: 80,
              height: 80,
              position: "relative",
              animation: `${spinAnimation} 1.5s linear infinite`,
            }}
          >
            {dots.map((pos, idx) => (
              <Box
                key={idx}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor: "#1A237E",
                  position: "absolute",
                  ...pos,
                }}
              />
            ))}
          </Box>
        </Box>
      )}

      {/* Card */}
      <Card sx={{ width: "1000px", padding: 3, margin: "auto" }}>
        <MDBox pt={4} pb={3} px={3}>
          <CustomStepper   sx={{ color: "#3949AB", fontWeight: 600 }}title="Register Device" />

          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
<Grid item xs={6}>
  <TextField
    select
    fullWidth
    label="Device Type"
    value={mappingDetails.devicetype}
    onChange={(e) =>
      setMappingDetails({ ...mappingDetails, devicetype: e.target.value })
    }
    sx={{
  '& .MuiInputBase-root': {
    height: 47,
  },
}}

  >
    <MenuItem value="BP Monitor">BP Monitor</MenuItem>
    <MenuItem value="Glucometer">Glucometer</MenuItem>
    <MenuItem value="Wrist Watch">Wrist Watch</MenuItem>
    <MenuItem value="Weighing Scale">Weighing Scale</MenuItem>
  </TextField>

  {errors.devicetype && (
    <span style={{ color: "red", fontSize: "13px" }}>
      {errors.devicetype}
    </span>
  )}
</Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Device Name"
                  value={mappingDetails.devicename}
                  onChange={(e) =>
                    setMappingDetails({ ...mappingDetails, devicename: e.target.value })
                  }
                />
                {errors.devicename && (
                  <span style={{ color: "red", fontSize: "13px" }}>
                    {errors.devicename}
                  </span>
                )}
              </Grid>

             

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Manufacturer"
                  value={mappingDetails.manufacturer}
                  onChange={(e) =>
                    setMappingDetails({ ...mappingDetails, manufacturer: e.target.value })
                  }
                />
                {errors.manufacturer && (
                  <span style={{ color: "red", fontSize: "13px" }}>
                    {errors.manufacturer}
                  </span>
                )}
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Model Number"
                  value={mappingDetails.modelnumber}
                  onChange={(e) =>
                    setMappingDetails({ ...mappingDetails, modelnumber: e.target.value })
                  }
                />
                {errors.modelnumber && (
                  <span style={{ color: "red", fontSize: "13px" }}>
                    {errors.modelnumber}
                  </span>
                )}
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Serial Number"
                  value={mappingDetails.serialnumber}
                  onChange={(e) =>
                    setMappingDetails({ ...mappingDetails, serialnumber: e.target.value })
                  }
                />
                {errors.serialnumber && (
                  <span style={{ color: "red", fontSize: "13px" }}>
                    {errors.serialnumber}
                  </span>
                )}
              </Grid>

              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Description"
                  value={mappingDetails.description}
                  onChange={(e) =>
                    setMappingDetails({ ...mappingDetails, description: e.target.value })
                  }
                />
                {errors.description && (
                  <span style={{ color: "red", fontSize: "13px" }}>
                    {errors.description}
                  </span>
                )}
              </Grid>
            </Grid>

           
             <MDBox mt={3} display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                onClick={() => navigate(-1)}
                // type="submit"
                sx={{
                  background: "#1A237E !important",
                  color: "#fff !important",
                  boxShadow: "none !important",
                  "&:hover": {
                    background: "#1A237E !important",
                    boxShadow: "none !important",
                  },
                  "&:focus": {
                    background: "#1A237E !important",
                    boxShadow: "none !important",
                    outline: "none",
                  },
                  "&:active": {
                    background: "#1A237E !important",
                    boxShadow: "none !important",
                  },
                  mr: 1, // small space between buttons
                }}
              >
                Cancel
              </MDButton>
            
              <MDButton
                variant="gradient"
                type="submit"
                sx={{
                  background: "#1A237E !important",
                  color: "#fff !important",
                  boxShadow: "none !important",
                  "&:hover": {
                    background: "#1A237E !important",
                    boxShadow: "none !important",
                  },
                  "&:focus": {
                    background: "#1A237E !important",
                    boxShadow: "none !important",
                    outline: "none",
                  },
                  "&:active": {
                    background: "#1A237E !important",
                    boxShadow: "none !important",
                  },
                }}
              >
                Submit
              </MDButton>
            </MDBox>
          </form>
        </MDBox>
      </Card>
    </DashboardLayout>
  );
}

export default RegisterDevice;
